import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import Card from "../ui/Card";
import { EmptyState } from "../ui/Table";
import { TrendingDown } from "lucide-react";
import { getChurnRateSeries } from "../../lib/calculations";

export default function ChurnChart({ clients }) {
  const data = getChurnRateSeries(clients, 12);
  const empty = data.every((d) => d.churnRate === 0);
  return (
    <Card title="Monthly churn rate (last 12 months)">
      {empty ? (
        <EmptyState icon={TrendingDown} title="No churn data yet" message="Once clients churn, the trend will appear here." />
      ) : (
        <div style={{ width: "100%", height: 280 }}>
          <ResponsiveContainer>
            <LineChart data={data}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" vertical={false} />
              <XAxis dataKey="month" tick={{ fontSize: 11, fill: "#6d7a97" }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fontSize: 11, fill: "#6d7a97" }} axisLine={false} tickLine={false} tickFormatter={(v) => `${v.toFixed(0)}%`} />
              <Tooltip formatter={(v) => `${v.toFixed(1)}%`} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
              <Line type="monotone" dataKey="churnRate" name="Churn rate" stroke="#dc2626" strokeWidth={2} dot={{ r: 3 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </Card>
  );
}
